import React, { Fragment, useState } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { useTranslation } from 'components/translation/TranslationProvider';
import { FormTextArea } from 'components/form/FormTextArea';
import './DealRejectModal.scss';
/**
 * @component DealRejectModal
 * @since 1.0.0
 * @hidden
 */
export function DealRejectModal(props) {
    const { onClose, onConfirm } = props;
    const [message, setMessage] = useState('');
    const { customLabels, language } = useTranslation();
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement("div", { className: "deal-reject-modal-button-container" },
            React.createElement(Button, { style: "primary", label: t('Send'), onPress: () => onConfirm(message) }))));
    return (React.createElement("div", { className: "deal-reject-modal" },
        React.createElement(Modal, { picto: "file-check", title: `${customLabels['Deal'][language]} ${t('Reject')}`, onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-reject-modal-content" },
                React.createElement(FormTextArea, { name: "reason", label: t('Reason'), required: true, style: "normal", onChange: (value) => setMessage(value) })))));
}
